import { createAsyncThunk } from "@reduxjs/toolkit";

import { errorToast, loadingToast, successToast } from "@/component/toasts";
import {
  createStaffDoc,
  deleteStaffDoc,
  getStaffDoc,
  updateStaffDoc,
} from "@/services/staff/documents";

export const getStaffDocsAsync = createAsyncThunk(
  "staff/getStaffDocs",
  async (id: string | undefined = undefined) => {
    try {
      const response = await getStaffDoc(id);
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const createStaffDocAsync = createAsyncThunk(
  "staff/createStaffDoc",
  async (data: any) => {
    let response;
    loadingToast("Creating Staff Document");
    try {
      response = await createStaffDoc(data);
      successToast("Staff Document created successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const updateStaffDocAsync = createAsyncThunk(
  "staff/updateStaffDoc",
  async (data: any) => {
    let response;
    loadingToast("Updating Staff Document");
    try {
      response = await updateStaffDoc(data.get("id"), data);
      successToast("Staff Document updated successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const deleteStaffDocAsync = createAsyncThunk(
  "staff/deleteStaffDoc",
  async (id: string) => {
    let response;
    loadingToast("Deleting Staff Document");
    try {
      response = await deleteStaffDoc(id);
      successToast("Staff Document deleted successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);
